import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { gray, marketingMobileCuttoff } from '@css/constants'

export const FeatureVideoWrapper = styled('div')<{
  minHeight: number
}>(props => css`
  overflow: hidden;
  margin: 0;
  background-color: ${gray};
  width: 100%;
  min-height: ${props.minHeight}px;
`)

export const Video = styled('video')(css`
  @media(max-width: 414px) {
    margin-left: calc(50% - 207px);
  }

  @media(min-width: ${marketingMobileCuttoff}) {
    margin-left: calc(50% - 720px);
  }
`)
